import { useMemo } from 'react';

import qs from 'qs';

import { useQuestionLabel } from '../../../../../../../../hooks/useQuestionLabel';
import { usePetitionReportAbuseContext } from '../../../../../../../../shared/context';
import type { FieldType, LinkQuestion } from '../../../../../../../../shared/types';

type Result = ModelHookResult<{
	questionLabel: string;
	urlWithParams: string;
}>;

type Props = {
	parent: FieldType;
	question: LinkQuestion;
};

export function useLinkQuestionField({ parent, question }: Props): Result {
	const reportContext = usePetitionReportAbuseContext();
	const {
		data: { questionLabel },
	} = useQuestionLabel(parent, question.name);

	const queryParams = useMemo(() => {
		if (!question.queryParams) return {};
		return Object.entries(question.queryParams).reduce((acc, [queryParamName, contextName]) => {
			const queryParamValue = reportContext[contextName];
			return { ...acc, [queryParamName]: queryParamValue };
		}, {});
	}, [question, reportContext]);

	const urlWithParams = useMemo(() => {
		return `${question.url}${qs.stringify(queryParams, { addQueryPrefix: true })}`;
	}, [queryParams, question.url]);

	return {
		data: {
			questionLabel,
			urlWithParams,
		},
	};
}
